import React from "react"
import { useLocation } from "react-router"
import { useNavigate } from "react-router-dom"

import logo from "../../../assets/common/logo-dark.jpg"
import { COMMON_IMAGE_URL } from "../../../config"
import { useDarkMode } from "../../../context/DarkModeContext"
import Basket from "../../Basket"
import DarkModeToggle from "../../DarkModeToggle"
import CountrySelect from "../../GlobalCountry"
import NavBar from "../../Navbar"
import Notification from "../../Notification"
import Profile from "../../Profile"

const Header = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const { isDarkMode } = useDarkMode()
    const { user_details }  = sessionStorage.getItem("userDetails")
        ? JSON.parse(sessionStorage.getItem("userDetails"))
        : ""
    const isLoginRoute = (location.pathname === "/" || location.pathname === "/registration" || location.pathname === "/home")
    
    // Choose logo based on dark mode
    const logoImage = isDarkMode ? logo : COMMON_IMAGE_URL+"Gas-logo.jpg"
    
    const redirectToHome=()=>{
        if(user_details){
            navigate("/dashboard")
        } else {
            navigate("/")
        }
    }  

    return (
        <div className="fixed w-full top-0 z-[10] no-print z-[11] text-black dark:text-white">
            <div className="flex flex-wrap px-3 sm:px-4 md:px-6 lg:px-8 justify-between items-center bg-white dark:bg-darkBg" style={{ paddingRight: "0" }}>
                <div className="flex-shrink-0 py-2">
                    <img 
                        fetchPriority="high" 
                        loading="lazy" 
                        src={`${logoImage}`} 
                        className="h-[38px] sm:h-[40px] md:h-[42px] w-auto max-w-[220px] sm:max-w-[260px] md:max-w-[300px] lg:max-w-[346px] object-contain"
                        alt="logos" 
                    />
                    <button onClick={redirectToHome} className="absolute top-px left-3 sm:left-4 md:left-6 lg:left-8 w-24 sm:w-28 md:w-32 h-10 cursor-pointer" aria-label="Go to Home"></button>
                </div>
                <div className={user_details !== undefined ? "flex items-center justify-end gap-2 sm:gap-3 md:gap-5 lg:gap-8 ml-auto" : "hidden"}>
                    {!isLoginRoute && (
                        <>
                            <div className="hidden sm:block">
                                <Basket />
                            </div>
                            <div className="hidden sm:block">
                                {<Notification />}
                            </div>
                            <Profile />
                        </>
                    )}
                    <DarkModeToggle />
                    <CountrySelect />
                </div>
            </div>
            {!isLoginRoute && <NavBar />}
        </div>
    )
}

export default Header
